//#region src/core/AmplitudeSink.ts
var e = "https://api2.amplitude.com/2/httpapi", t = 1e3, n = class extends Error {
	constructor(e, t, n) {
		super(e), this.status = t, this.retryable = n, this.name = "FlushError";
	}
};
function r(e, t) {
	let n = [];
	for (let r = 0; r < e.length; r += t) n.push(e.slice(r, r + t));
	return n;
}
var i = class {
	constructor(e) {
		this.apiKey = e;
	}
	async flush(e, n = {}) {
		if (e.length !== 0) for (let i of r(e, t)) await this.send(i, n);
	}
	async send(t, r) {
		let i = JSON.stringify({
			api_key: this.apiKey,
			events: t.map((e) => this.toAmplitudeEvent(e))
		});
		if (r.useBeacon && typeof navigator < "u" && navigator.sendBeacon) {
			if (!navigator.sendBeacon(e, new Blob([i], { type: "application/json" }))) throw new n("Amplitude sendBeacon refused", null, !0);
			return;
		}
		let a;
		try {
			a = await fetch(e, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "*/*"
				},
				body: i
			});
		} catch (e) {
			throw new n(`Amplitude flush network error: ${String(e)}`, null, !0);
		}
		if (!a.ok) {
			let e = a.status >= 500 || a.status === 429;
			throw new n(`Amplitude flush failed: ${a.status} ${a.statusText}`, a.status, e);
		}
	}
	toAmplitudeEvent(e) {
		let { userId: t, sessionId: n, platform: r, appVersion: i, ...a } = e.context;
		return {
			event_type: e.name,
			time: e.timestamp,
			insert_id: e.id,
			user_id: t ?? void 0,
			session_id: n,
			event_properties: e.payload,
			user_properties: a,
			platform: r,
			app_version: i
		};
	}
};
//#endregion
export { i as AmplitudeSink, n as FlushError };
